module.exports = __webpack_public_path__ + "static/stencil-page2-72dpi-f0667dc058c98581afc97dd8e766b41c.png";